(function () {
    /* global braintree */

    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * This service is responsible for interaction with braintree. It houses the main
     * braintree setup function as well as braintree teardown.
     */
    angular
        .module('ihh-common-web')
        .service('PaymentMethodEntryService', PaymentMethodEntryService);

    PaymentMethodEntryService.$inject = ['$q', 'RestResources', 'Utilities', '$modalStack'];

    function PaymentMethodEntryService($q, RestResources, Utilities, $modalStack) {
        var self = this;
        var paymentTokenRecord;
        var checkout;
        var nonceObj;

        /**
         * This function is used to setup braintree, and define the required callbacks.
         * @param {string} clinicId - the id of the clinic
         */
        self.setupBraintree = function (clinicId, onPaymentMethodReceivedCallback) {
            var deferred = $q.defer();
            var paymentTokenResource = RestResources.getClinicPaymentTokensResource(clinicId);

            paymentTokenResource.save(function(queryResult) {
                paymentTokenRecord = queryResult;

                braintree.setup(paymentTokenRecord.token, 'dropin', {
                    container: 'payment-form',
                    onReady: function (integration) {
                        checkout = integration;
                    },
                    onPaymentMethodReceived: function (obj) {
                        onPaymentMethodReceivedCallback(obj).then(function () {
                            self.teardownBraintree();
                            deferred.resolve();
                        });
                    },
                    onError: function (obj) {
                        deferred.reject(obj.message);
                    }
                });
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        };

        // When you are ready to tear down your integration
        self.teardownBraintree = function () {
            checkout.teardown(function () {
                checkout = null;
                // braintree.setup can safely be run again!
                $modalStack.dismissAll();
            });
        };

        self.getPaymentMethodNonce = function () {
            var deferred = $q.defer();

            if (Utilities.isDefinedAndNotNull(nonceObj)) {
                deferred.resolve(nonceObj);
            }
            else {
                deferred.reject();
            }

            return deferred.promise;
        };

        return self;
    }
})();


